export type CatalogStatus = 'available' | 'soon';

export interface CatalogForm {
  id: string;
  title: string;
  summary: string;
  minutes: number;
  category: string;
  tint: 'sky' | 'mint' | 'rose' | 'plain';
  status: CatalogStatus;
  requirements: string[];
  keywords: string[];
}

export const CATEGORIES = [
  'הוראה ושיבוצים',
  'מלגות ומחקר',
  'שירות מילואים והתאמות',
  'רישום לקורסים',
  'בחינות ומועדים',
  'מנהלה ופרטים אישיים',
];

export const CATALOG: CatalogForm[] = [
  {
    id: 'teaching-assignment',
    title: 'בקשה לשיבוץ לשנת הלימודים (Teaching Assignment)',
    summary:
      'טופס הגשת בקשה רשמי לשיבוץ הוראה (עוזרי הוראה, מדריכים, מתרגלים ובודקים) בפקולטה להנדסה. כולל בחירת סמסטר, יחידה אקדמית וצירוף אישור מרצה.',
    minutes: 5,
    category: 'הוראה ושיבוצים',
    tint: 'mint',
    status: 'available',
    requirements: ['תעודת זהות ודוא״ל', 'פרטי הקורס והסמסטר', 'אישור מרצה חתום (PDF/תמונה)'],
    keywords: ['שיבוץ', 'הוראה', 'עוזר הוראה', 'מתרגל', 'מדריך', 'בודק תרגילים', 'מרצה', 'teaching', 'assignment', 'סמסטר'],
  },
  {
    id: 'postdoc-bursary',
    title: 'בקשה למלגת פוסט-דוקטורט (Postdoc Bursary)',
    summary:
      'טופס הגשת בקשה רשמי למלגת פוסט-דוקטורט בפקולטה להנדסה. כולל פרטים אישיים, מען, חשבון בנק, מעבדת המנחה וצירוף מסמכים.',
    minutes: 6,
    category: 'מלגות ומחקר',
    tint: 'sky',
    status: 'available',
    requirements: ['ת"ז / דרכון בתוקף', 'פרטי חשבון בנק', 'תעודות השכלה ואי��ור קבלה', 'חתימה דיגיטלית'],
    keywords: ['מלגה', 'פוסט דוקטורט', 'postdoc', 'bursary', 'הנדסה', 'מחקר', 'מנחה', 'מעבדה'],
  },
  {
    id: 'military-declaration',
    title: 'הצהרת מילואים',
    summary:
      'דיווח על תקופת שירות מילואים ועל השיעורים, המעבדות, הבחינות וההגשות שהוחמצו בעקבותיה, לצורך קבלת ההתאמות המגיעות.',
    minutes: 7,
    category: 'שירות מילואים והתאמות',
    tint: 'sky',
    status: 'available',
    requirements: ['צו מילואים או אישור שירות', 'מספר תעודת סטודנט', 'רשימת הקורסים שהוחמצו'],
    keywords: ['מילואים', 'צו 8', 'שירות', 'הצהרה', 'התאמות'],
  },
  {
    id: 'post-bidding',
    title: 'בקשה לפוסט בידינג',
    summary:
      'בקשת רישום לקורסים לאחר שלב הבידינג. בחירת הקורסים נעשית מתוך תכנית הלימוד והסמסטר, ופרטי הקורס נשלפים אוטומטית.',
    minutes: 4,
    category: 'רישום לקורסים',
    tint: 'mint',
    status: 'available',
    requirements: ['מספר תעודת זהות', 'תכנית הלימוד והסמסטר', 'הצהרה על השתתפות בבידינג'],
    keywords: ['בידינג', 'פוסט בידינג', 'רישום', 'קורסים', 'תכנית לימוד'],
  },
  {
    id: 'special-exam',
    title: 'בקשה למועד מיוחד',
    summary: 'בקשה לקבלת מועד בחינה נוסף מעבר למועדים הרגילים, בצירוף האסמכתאות הרלוונטיות.',
    minutes: 5,
    category: 'בחינות ומועדים',
    tint: 'mint',
    status: 'soon',
    requirements: ['אישור רלוונטי', 'מספר הקורס'],
    keywords: ['מועד מיוחד', 'בחינה', 'מועד ג'],
  },
  {
    id: 'submission-extension',
    title: 'בקשה לדחיית מועד הגשה',
    summary: 'בקשה לדחיית הגשה של תרגיל בית, עבודה או פרויקט, בתיאום עם המרצה האחראי.',
    minutes: 4,
    category: 'בחינות ומועדים',
    tint: 'rose',
    status: 'soon',
    requirements: ['אישור המרצה', 'מספר הקורס'],
    keywords: ['הגשה', 'דחייה', 'פרויקט', 'עבודה'],
  },
  {
    id: 'attendance-exemption',
    title: 'בקשה לפטור מדרישת נוכחות',
    summary: 'בקשה לפטור מחובת נוכחות בתרגילים או במעבדות, כולל דרך ההשלמה המוצעת.',
    minutes: 4,
    category: 'שירות מילואים והתאמות',
    tint: 'plain',
    status: 'soon',
    requirements: ['אישור רלוונטי', 'מספר הקורס'],
    keywords: ['נוכחות', 'פטור', 'מעבדה', 'תרגיל'],
  },
  {
    id: 'personal-details',
    title: 'עדכון פרטים אישיים',
    summary: 'עדכון כתובת, טלפון ודואר אלקטרוני במערכות הפקולטה.',
    minutes: 3,
    category: 'מנהלה ופרטים אישיים',
    tint: 'plain',
    status: 'soon',
    requirements: ['תעודת זהות'],
    keywords: ['פרטים', 'כתובת', 'טלפון', 'אימייל'],
  },
];

export function filterCatalog(term: string): CatalogForm[] {
  const needle = term.trim().toLowerCase();
  if (!needle) return CATALOG;
  return CATALOG.filter((form) => {
    const haystack = [form.title, form.summary, form.category, ...form.keywords].join(' ').toLowerCase();
    return haystack.includes(needle);
  });
}

export const TINT_CLASS: Record<CatalogForm['tint'], string> = {
  sky: 'bg-[hsl(var(--tint-sky))]',
  mint: 'bg-[hsl(var(--tint-mint))]',
  rose: 'bg-[hsl(var(--tint-rose))]',
  plain: 'bg-[hsl(var(--surface-1))]',
};
